import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  WAREHOUSE_RECEIVING_ORDERS_INDEX_REQUESTED,
  WAREHOUSE_RECEIVING_ORDERS_INDEX_SUCCESS,
  WAREHOUSE_RECEIVING_ORDERS_INDEX_FAILURE,
  WAREHOUSE_RECEIVING_ORDER_FIND_REQUESTED,
  WAREHOUSE_RECEIVING_ORDER_FIND_SUCCESS,
  WAREHOUSE_RECEIVING_ORDER_FIND_FAILURE,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_REQUESTED,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_SUCCESS,
  WAREHOUSE_RECEIVING_ORDER_REMOVE_FAILURE,
} from '../types';


export const findWarehouseReceivingOrderRequested = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_FIND_REQUESTED
  }
};

export const findWarehouseReceivingOrderSuccess = (warehouseReceivingOrder) => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_FIND_SUCCESS,
    payload: warehouseReceivingOrder
  }
};

export const findWarehouseReceivingOrderFailure = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_FIND_FAILURE
  }
};


export const removeWarehouseReceivingOrderRequested = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_REMOVE_REQUESTED
  }
};

export const removeWarehouseReceivingOrderSuccess = (warehouseReceivingOrders) => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_REMOVE_SUCCESS,
    payload: warehouseReceivingOrders
  }
};

export const removeWarehouseReceivingOrderFailure = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDER_REMOVE_FAILURE
  }
};



export const warehouseReceivingOrdersIndexRequested = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDERS_INDEX_REQUESTED
  }
};

export const warehouseReceivingOrdersIndexSuccess = (warehouseReceivingOrders) => {
  return {
    type: WAREHOUSE_RECEIVING_ORDERS_INDEX_SUCCESS,
    payload: warehouseReceivingOrders
  }
};

export const warehouseReceivingOrdersIndexFailure = () => {
  return {
    type: WAREHOUSE_RECEIVING_ORDERS_INDEX_FAILURE
  }
};


export const warehouseReceivingOrdersIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(warehouseReceivingOrdersIndexRequested());

    let endPoint = Config.baseUrl + Config.warehouseReceivingOrders;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(warehouseReceivingOrdersIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(warehouseReceivingOrdersIndexFailure());
      });
  }
}

export const findWarehouseReceiveingOrder = (signedPayload, id) => {
  return (dispatch) => {
    dispatch(findWarehouseReceivingOrderRequested());

    let endPoint = Config.baseUrl + Config.warehouseReceivingOrder + id;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(findWarehouseReceivingOrderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(findWarehouseReceivingOrderFailure());
      });
  }
}

export const removeWarehouseReceiveingOrder = (signedPayload, id) => {
  return (dispatch) => {
    dispatch(removeWarehouseReceivingOrderRequested());

    let endPoint = Config.baseUrl + Config.warehouseReceivingOrder + id;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(removeWarehouseReceivingOrderSuccess(response.data));
      })

  }
}
